import moment from 'moment';
import { useCallback, useEffect, useMemo } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { Spinner } from '../../../../../components/Spinner';
import VirtualizedList from '../../../../../components/VirtualizedList';
import { EVENT_LOG_TYPE_COLOR } from '../../../../../constants/fundings';
import { getTextWidthInOneLine } from '../../../../../utils/strings';

function NewFundingEventsLogTab({
  fundingLog,
  refreshTab,
  setRefreshTab,
  spinner,
  setSpinner,
  refreshFundingData,
}) {
  const eventsLog = useMemo(() => fundingLog.sort((a, b) => b.id - a.id), [fundingLog]);

  const getEventsLog = useCallback(async () => {
    setSpinner(true);
    await refreshFundingData();
    setSpinner(false);
  }, [refreshFundingData, setSpinner]);

  useEffect(() => {
    if (refreshTab === 'events_log') {
      getEventsLog();
      setRefreshTab('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshTab]);

  const tableColumns = useMemo(
    () => [
      {
        key: 'timestamp',
        header: 'Timestamp',
        width: 230,
        renderValue: value => `${moment.utc(value).local().format('MMM DD YYYY HH:mm (UTCZ)')}`,
      },
      {
        key: 'type',
        header: 'Type',
        width: 250,
        renderValue: value => (
          <p className={`${EVENT_LOG_TYPE_COLOR[value] || 'text-dark'} p-0 m-0`}>{value}</p>
        ),
      },
      {
        key: 'description',
        header: 'Description',
        width: 500,
        renderValue: value => <p className="m-0 p-0">{value}</p>,
      },
      { key: 'user', header: 'User', width: 200 },
    ],
    [],
  );

  const getRowHeight = useCallback(
    index => {
      const descriptionWidth = getTextWidthInOneLine(eventsLog[index].description);
      const descriptionHeight =
        descriptionWidth > 480 ? Math.ceil(descriptionWidth / 480) * 18 + 18 : 36;

      return Math.max(descriptionHeight, 36);
    },
    [eventsLog],
  );

  return (
    <AutoSizer>
      {({ height, width }) => (
        <Spinner visible={spinner} overlayWidth={width}>
          <VirtualizedList
            tableRows={eventsLog}
            tableColumns={tableColumns}
            width={width}
            height={height}
            getRowHeight={getRowHeight}
            rowKey="timestamp"
          />
        </Spinner>
      )}
    </AutoSizer>
  );
}

export default NewFundingEventsLogTab;
